import { helper } from '@ember/component/helper';

export function subtractNumber([a, b]) {
  return parseInt(a) - parseInt(b);
}

export default helper(subtractNumber);
